import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import i18n from '@dms/i18n';
import {useWorkshopInterestEditPermissions} from '@dms/shared';

import {buildArray} from 'shared/web';

import {ActivityTab} from './ActivityPanel/ActivityTab';
import {WorkshopInterestCommentsTab} from './ActivityPanel/WorkshopInterestCommentsTab';

type WorkshopInterestActivityPanelProps = {
  interestId: string;
};

export function WorkshopInterestActivityPanel(props: WorkshopInterestActivityPanelProps) {
  const {hasReadCommentsPermission} = useWorkshopInterestEditPermissions({
    interestId: props.interestId,
  });

  const actions = buildArray<ActivitySidebarAction>()
    .add({
      id: 'activity',
      label: i18n.t('entity.activityPanel.activity.title'),
      icon: 'sidebar/activity',
      component: <ActivityTab interestId={props.interestId} />,
    })
    .when(hasReadCommentsPermission, {
      id: 'comments',
      label: i18n.t('entity.activityPanel.comments.title'),
      icon: 'communication/comment',
      component: <WorkshopInterestCommentsTab interestId={props.interestId} />,
    });

  return <ActivitySidebarV2 actions={actions} />;
}
